import { useState } from 'react';
import { Grid, Tabs, Tab } from '@mui/material';
import RofBiocharApplication from './data-monitoring/application/RofBiocharApplication';
import RofProduction from './data-monitoring/production/RofProduction';

const FLAME_CAP_KILN_TABS = [
    'Production',
    'Application',
    'Charging',
    'Field Notes'
]

const DISABLED_TABS = ['Charging', 'Field Notes']

export default function RofDataMonitoring() {
    const [selectedTab, setSelectedTab] = useState('Production');

    return (
        <Grid container gap={3}>
            <Grid item sx={{ display: 'flex', width: '100%' }}>
                <Tabs
                    value={selectedTab}
                    onChange={(event, newValue) => setSelectedTab(newValue)}
                >
                    {FLAME_CAP_KILN_TABS.map((tab) => (
                        <Tab
                            key={tab}
                            label={tab}
                            value={tab}
                            disabled={DISABLED_TABS.includes(tab)}
                        />
                    ))}
                </Tabs>
            </Grid>
            {
                selectedTab === 'Production' &&
                <RofProduction />
            }
            {
                selectedTab === 'Application' &&
                <RofBiocharApplication />
            }
        </Grid>
    );
}
